import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Breadcrumb from "@/components/feature/Breadcrumb";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/content";

export default function Faq() {
  useSeo({
    title: "常见问题 - 黑料吃话内容说明与投稿答疑",
    description:
      "关于黑料吃话的常见问题解答：内容范围、脱敏化准则、观点性质、更新频率、投稿方式与订阅说明，帮助你快速了解本站的运作方式。",
    keywords: "黑料吃话,常见问题,黑料吃话投稿,内容准则,订阅说明",
    path: "/faq",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: `${window.location.origin}/` },
          { "@type": "ListItem", position: 2, name: "常见问题", item: `${window.location.origin}/faq` },
        ],
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />

      <main className="flex-1">
        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-8">
            <span className="text-xs font-medium tracking-[0.24em] text-primary-600">FAQ</span>
            <h1 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">常见问题</h1>
            <p className="mt-4 max-w-2xl text-sm leading-8 text-foreground-600">
              这里整理了读者最常问到的问题。如果下面没有你要的答案，欢迎直接来信，我们会把高频问题补充进来。
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-8">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
              <div className="lg:col-span-8">
                <FaqAccordion items={faqs} />
              </div>
              <aside className="lg:col-span-4">
                <div className="rounded-lg border border-background-200 bg-background-100 p-6">
                  <i className="ri-question-answer-line text-2xl text-primary-600"></i>
                  <h2 className="mt-3 font-heading text-lg font-bold text-foreground-950">还有疑问？</h2>
                  <p className="mt-2 text-sm leading-7 text-foreground-600">
                    没找到答案的话，直接联系我们。合作、投稿与纠错都走同一个入口。
                  </p>
                  <Link
                    to="/contact"
                    className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-mail-send-line"></i>联系我们
                  </Link>
                </div>

                <div className="mt-6 rounded-lg bg-secondary-900 p-6">
                  <h2 className="font-heading text-base font-bold text-background-50">阅读建议</h2>
                  <p className="mt-2 text-sm leading-7 text-secondary-200">
                    建议先看「关于我们」里的内容准则，再来读解读文章，会更容易理解我们为什么这样组织信息。
                  </p>
                  <Link
                    to="/about"
                    className="mt-4 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-300 hover:text-accent-200"
                  >
                    查看关于我们 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </aside>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}